export default class specManager {
    constructor(scroll) {
        this.$trigger = document.querySelector('#p-award-more .c-btn');
        this.$list = document.querySelectorAll('.p-award-list-contents');
        this.$listItem = document.querySelectorAll('.p-award-list-contents .list-item');
        this.scroll = scroll;
    }

    init() {


        this.$trigger.addEventListener("click", (event) => {
            event.preventDefault();

            // $listからclassを削除
            for (let i = 0; i < this.$list.length; i++) {
                // is-hideを持っている場合
                if (this.$list[i].classList.contains('is-hide') || this.$list[i].classList.contains('is-sp-hide')) {
                    this.$list[i].classList.remove('is-hide', 'is-sp-hide');
                }
            }

            // $listItemからclassを削除
            for (let i = 0; i < this.$listItem.length; i++) {
                // is-hideを持っている場合
                if (this.$listItem[i].classList.contains('is-hide') || this.$listItem[i].classList.contains('is-sp-hide')) {
                    this.$listItem[i].classList.remove('is-hide', 'is-sp-hide');
                }
            }

            // ボタン非表示
            this.$trigger.classList.add('is-hide');

            // 高さ調整
            let _w = window.innerWidth;
            let _h = window.innerHeight;
            this.scroll.resize();

        }, {passive: false});


    }
}

